// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "_static/" + chunkId + "." + {"169":"fb987ee940737286a77f","411":"4483d4aa34e1d3a9c976","651":"2ab398fd14bac698cd83","855":"9ae25e2010c5c0bf4a8a"}[chunkId] + ".js";
};